import { Metamodel } from 'app/model/base/model';
import { AzurePostgreSqlCopySource } from 'app/model/pipeline/copysource/azure-postgresql.copysource';
import { AzureHorizonDBTableDataset } from 'app/model/dataset/azure-horizon-db-table.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

/**
 * Azure HorizonDB is PostgreSQL wire-compatible, so its copy source reuses the exact same
 * serialization shape and behavior as the Azure Database for PostgreSQL copy source. It is
 * modeled as its own copy-source type ('AzureHorizonDBSource') bound to the HorizonDB dataset.
 */
@Metamodel.model({
    name: adfModelTypeMap.azureHorizonDb.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(AzureHorizonDBTableDataset) }
})
export class AzureHorizonDBCopySource extends AzurePostgreSqlCopySource {
}
